// 处分申诉管理
export default [
    {
        path: '/appeal',
        component: resolve => require(['@/pages/appeal/appeal.vue'], resolve),
        name: 'appeal',
        meta: {
            title: '处分申诉管理'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/modules/appeal.js